module.exports = __webpack_public_path__ + "static/media/jhonor-bg.a5a67fea.jpg";